import React, { useEffect, useState } from "react";
import { NavSettings } from "@/lib/api";

/**
 * SiteBackground — a global fixed-position image layer rendered UNDER
 * all site content. Reads `site_background_url` + `site_background_opacity`
 * from /api/nav-settings. Refreshes when the admin preview refresh event fires.
 */
const SiteBackground = () => {
  const [url, setUrl] = useState("");
  const [opacity, setOpacity] = useState(0.18);

  const load = async () => {
    try {
      const s = await NavSettings.get();
      setUrl(s.site_background_url || "");
      const op = Number(s.site_background_opacity);
      if (Number.isFinite(op)) setOpacity(Math.max(0, Math.min(1, op)));
    } catch { /* ignore */ }
  };

  useEffect(() => {
    load();
    const onRefresh = () => load();
    window.addEventListener("atc-preview-refresh", onRefresh);
    return () => window.removeEventListener("atc-preview-refresh", onRefresh);
  }, []);

  if (!url) return null;

  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 pointer-events-none -z-10"
      data-testid="site-background"
      style={{
        backgroundImage: `url(${url})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        opacity,
      }}
    />
  );
};

export default SiteBackground;
